import type { SVGProps } from 'react';

export default function HugeiconsSwipeLeft08(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth={1.5}>
        <path
          strokeLinejoin="round"
          d="M15.008 4.497h5.991m-5.991 0c0-.7 1.991-2.006 2.496-2.497m-2.496 2.497c0 .7 1.991 2.006 2.496 2.497"
        ></path>
        <path d="M6.536 14.446v-4.47m0 0v-5.52c0-.821.685-1.482 1.506-1.482c.822 0 1.469.661 1.469 1.482v4M6.536 9.978c-1.317 1.192-2.734 2.698-2.925 3.084c-.888 1.35-.795 2.005.195 3.657a41 41 0 0 0 2.037 3.036c.671.76.538.76 1.511 1.475c.87.602 2.673 1.023 6.9.602c3.444-.53 4.27-3.534 4.251-4.97v-3.543c.215-2.946-1.018-3.08-3.256-3.37M9.511 8.457v2.527m0-2.527c.558-.91 2.587-.542 2.982 1.176m.036 1.347V9.977q0-.12-.015-.236m-.02-.11q0 .012.004.022l.016.088m-.02-.11q.005.053.02.11m-.02-.11c-.141-1.197 2.896-.905 3.02 1.201v1.145"></path>
      </g>
    </svg>
  );
}
